import kartawijaya from "./kartawijaya.webp";
import kartawijaya2 from "./kartawijaya (2).jpeg";
import kartawijaya3 from "./kartawijaya (3).jpeg";
import kartawijaya4 from "./kartawijaya (4).jpeg";
import kartawijaya5 from "./kartawijaya (5).jpeg";
import kartawijaya6 from "./kartawijaya (6).jpeg";
import kartawijaya7 from "./kartawijaya (7).jpeg";
import kartawijaya8 from "./kartawijaya (8).jpeg";
import kartawijaya9 from "./kartawijaya (9).jpeg";
import kartawijaya10 from "./kartawijaya (10).jpeg";
import kartawijaya11 from "./kartawijaya (11).jpeg";

const kartawijayaImages = [
  kartawijaya,
  kartawijaya2,
  kartawijaya3,
  kartawijaya4,
  kartawijaya5,
  kartawijaya6,
  kartawijaya7,
  kartawijaya8,
  kartawijaya9,
  kartawijaya10,
  kartawijaya11,
];

export default kartawijayaImages;
